import { processEventStateTypes } from "../enums/processEventStateTypes";

export class ProcessingEventData {
  public type: processEventStateTypes;
  public overlayText: string;
}
